import React from "react";
import { Table } from "react-bootstrap";
import "./EditableDataTable.css";
import { Column } from "./types/column";

interface EditableDataTableProps {
  records: any[];
  columns: Column[];
  config: {
    classForTable?: string;
    bordered?: boolean;
    striped?: boolean;
    hover?: boolean;
    multiselect?: boolean;
    dragAndDrop?: boolean;
    expandable?: boolean;
  };
}

function EditableDataTable({
  records,
  columns,
  config,
}: EditableDataTableProps) {
  const tableClass = `sansTable editableDataTable table ${
    config.classForTable ? config.classForTable : ""
  }`;
  return (
    <Table
      className={tableClass}
      bordered={config.bordered}
      striped={config.striped}
      hover={config.hover}
    >
      <thead>
        <tr>
          {columns.map((column, index) => {
            return (
              <th
                className={column.headerClass ? column.headerClass : ""}
                key={`header-data-${index}`}
              >
                {column.header()}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {records.map((record, index) => {
          return (
            <tr key={`table-row-${index}`}>
              {columns.map((column, index) => {
                return (
                  <td
                    className={column.cellClass ? column.cellClass : ""}
                    key={`table-data-${index}`}
                  >
                    {column.cell(record)}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default EditableDataTable;
